<template>
  <div>
    <!--条形图-->
    <div class="echarts">
       <div class="chart" ref="myEchartPillar" style="height:400px;width:97%;"></div>
     </div>
    <!--主体内容----信用评分-->
    <div class="project">产品服务</div>
    <div class="content">
        <div class="title">
          <img src="../../assets/3.png">
          <span>贸易行业</span>
        </div>
        <div class="title">
          <img src="../../assets/4.png">
          <span>物流行业</span>
        </div>
        <div class="title">
          <img src="../../assets/5.png">
          <span>应收账款</span>
        </div>
        <div class="title">
          <img src="../../assets/6.png">
          <span>其他</span>
        </div>
      </div>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import echarts from 'echarts'
  export default {
    name: "index",
    components: {MyButton},
    methods:{
      // 渲染柱形图表
      getPillar() {
        let that = this;
        // 基于准备好的dom(myEchartPillar)，初始化echarts实例
        let myChart = echarts.init(this.$refs.myEchartPillar);
        //指定图表的配置项和数据，绘制图表
        myChart.setOption({
          // 图表名称
          title: {
            text: "保理统计图"
          },
          // 图表颜色
          color: ["#6284d3"],
          // 提示
          tooltip: {
            //触发类型,axis:坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效，默认为直线，可选为：'line' | 'shadow'
              type: "shadow"
            }
          },
          grid: {
            show: true,
            //grid 组件离容器左侧的距离。
            left: "3%",
            //grid 组件离容器右侧的距离。
            right: "4%",
            //grid 组件离容器下侧的距离。
            bottom: "3%",
            //grid 区域是否包含坐标轴的刻度标签。true这常用于『防止标签溢出』的场景，标签溢出指的是，标签长度动态变化时，可能会溢出容器或者覆盖其他组件。
            containLabel: true,
            // 网格背景色，此配置项生效的前提是，设置了 show: true
            backgroundColor: "#E7F1F5"
          },
          //直角坐标系 grid 中的 x 轴
          xAxis: [
            {
              //'category' 类目轴
              type: "category",
              //坐标轴名称
              name: "名称",
              //坐标轴名称显示位置
              nameLocation: "end",
              //坐标数据
              data: ["总资产","可用余额","冻结金额","总保理金额","保理中","近一周应还金额",],
              //坐标轴刻度相关设置
              axisTick: {
                // 为 true 可以保证刻度线和标签对齐
                alignWithLabel: true
              },
              //坐标轴名称与轴线之间的距离
              nameGap: 2
            }
          ],
          //直角坐标系 grid 中的 y 轴
          yAxis: [
            {
              //'value' 数值轴，适用于连续数据
              type: "value",
              //坐标轴名称
              name: "金额(元)",
              //坐标轴的标签是否响应和触发鼠标事件，默认不响应
              triggerEvent: true
            }
          ],
          //系列列表。每个系列通过 type 决定自己的图表类型
          series: [
            {
              //系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列
              //类型为柱状/条形图
              type: "bar",
              //柱条的宽度，不设时自适应。支持设置成相对于类目宽度的百分比。
              barWidth: "60%",
              //图形上的文本标签，可用于说明图形的一些数据信息
              label: {
                normal: {
                  //是否显示标签
                  show: true,
                  //通过相对的百分比或者绝对像素值表示标签相对于图形包围盒左上角的位置
                  position: "top",
                }
              },
              //系列中的数据内容数组
              data: [this.asset.totalMoney,this.asset.balance, this.asset.freezeMoney,this.asset.totalLoanMoney,this.asset.loanMoney,this.asset.weekShouldRepayMoney,]
            }
          ]
        });
        //解决自适应
        setTimeout(function() {
          window.addEventListener("resize", () => {
            myChart.resize();
          });
        }, 500);
      },
      getAsset(){
        ApiClient.get('/desktop/profile/asset.do').then(data => {
          this.asset = data;
          this.getPillar()
        })
      },
    },
    data() {
      return {
        asset: {
          balance:'',
          freezeMoney: '',
          totalMoney:'',
          totalLoanMoney:'',
          weekShouldRepayMoney:'',
          loanMoney:''
        },
      }
    },
    mounted() {
      this.getAsset();
    },
  }
</script>
<style scoped lang="less">
  .content {
    width: 100%;
    margin-top: 20px;
    height:150px;
    display: flex;
  }
  .content .title {
    display: flex;
    flex-direction: column;
    width:25%;
  }
  .title img{
    width:100px;
    height:100px;
    margin:0 auto;
  }
  .title span{
    margin:0 auto;
  }
  .project{
    font-size: 22px;
    width:120px;
    margin-top:15px;
    text-align:center;
    background:#d8d8d8;
    font-weight:bold;
  }
</style>




// WEBPACK FOOTER //
// src/pages/index/index.vue